import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { Models } from '$models';
import { isFreddieMacProperty } from '../utils/is-freddie-mac.util';

/**
 * Renders its template when the property matches the canonical Freddie Mac rule:
 * (PROGRAMRECORDTYPE === 'First Look'
 *   || PROGRAMRECORDTYPE === 'Day 1'
 *   || PROGRAM_NAME === 'Day 1')
 *   && CYCLE === 1
 *
 * First Look restrictions apply only during the first auction cycle.
 *
 * USAGE: <div *isFreddieMac="property"> ... </div>
 */
@Directive({
  selector: '[isFreddieMac]',
})
export class IsFreddieMacDirective {
  private hasView = false;

  @Input() set isFreddieMac(property: Models.PropertyDetailsResponse | null | undefined) {
    const show = isFreddieMacProperty(property);
    if (show && !this.hasView) {
      this.vcr.createEmbeddedView(this.tpl);
      this.hasView = true;
    } else if (!show && this.hasView) {
      this.vcr.clear();
      this.hasView = false;
    }
  }

  constructor(private tpl: TemplateRef<unknown>, private vcr: ViewContainerRef) {}
}
